import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Header from './components/Header';
import HomePage from './components/HomePage';
import CreateEventPage from './components/CreateEventPage';
import EventPage from './components/EventPage';
import MyEventsPage from './components/MyEventsPage';
import AdminPage from './components/AdminPage';
import './index.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/"           element={<HomePage />} />
          <Route path="/create"     element={<CreateEventPage />} />
          <Route path="/event/:id"  element={<EventPage />} />
          <Route path="/my-events"  element={<MyEventsPage />} />
          <Route path="/admin"      element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
